import type { ExtractedFacts } from '../api/onboarding-types'

/** Trimmed, non-empty, de-duplicated lines, as the server saves them. */
export function cleanList(values: string[]): string[] {
  return [...new Set(values.map((v) => v.trim()).filter(Boolean))]
}

export function sameList(a: string[], b: string[]): boolean {
  const norm = (xs: string[]) => [...new Set(xs.map((x) => x.trim().toLowerCase()))].sort().join('\n')
  return norm(a) === norm(b)
}

/** A list the documents state (SDS first, then any other read document). */
export function docList(
  results: Record<string, ExtractedFacts> | null | undefined,
  key: 'inci_names' | 'cas_numbers',
): { label: string; values: string[] } | null {
  const entries = Object.entries(results ?? {}).sort(([a], [b]) => (a === 'sds' ? -1 : b === 'sds' ? 1 : 0))
  for (const [docKey, f] of entries) {
    const values = cleanList(f?.[key] ?? [])
    if (!f?.error && values.length) return { label: f.doc_type_label ?? docKey, values }
  }
  return null
}
